import React from 'react';
import { PACKAGES } from '../../../config/packages';
import './PackageSelector.css';

const PackageSelector = ({ selected, onSelect, currentPackage = 0, disabled = false }) => {
  const currentPkg = parseFloat(currentPackage);

  return (
    <div className="package-selector">
      <div className="package-grid">
        {PACKAGES.map((pkg, idx) => {
          const pkgValue = parseFloat(pkg.value);
          const isDisabled = disabled || pkgValue < currentPkg;
          const isSelected = selected === pkg.value;
          const isCurrent = pkgValue === currentPkg && currentPkg > 0;

          return (
            <button
              key={idx}
              className={`package-item ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''} ${isCurrent ? 'current' : ''}`}
              onClick={() => !isDisabled && onSelect(pkg.value)}
              disabled={isDisabled}
            >
              <span className="package-value">{pkg.value}</span>
              <span className="package-unit">USDT</span>
              {isCurrent && <span className="package-badge">Current</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PackageSelector;
